export enum Interaction {
  EditorReady = 'editor-ready',
  InstallApp = 'install-app',
  RemoveApp = 'remove-app',
  SearchBoxAdded = 'search-box-added',
}
